import Cart from "./Cart";

export default function MobileHeader() {

    return (
        <div className="apply-mobile-header">
            <Cart />
        </div>
    );
}